import {
  FETCH_PENDING_COURSES_REQUEST,
  FETCH_PENDING_COURSES_SUCCESS,
  FETCH_PENDING_COURSES_FAILURE,
  APPROVE_COURSE_SUCCESS,
  APPROVE_COURSE_FAILURE,
  FETCH_APPROVED_COURSES_REQUEST,
  FETCH_APPROVED_COURSES_SUCCESS,
  FETCH_APPROVED_COURSES_FAILURE,
  MARK_COURSE_PENDING_SUCCESS,
  MARK_COURSE_PENDING_FAILURE,
} from "../Actions/types";

// Pending courses reducer
const initialStatePending = {
  loading: false,
  pendingCourses: [],
  error: null,
};

export const courseAdminReducer = (state = initialStatePending, action) => {
  switch (action.type) {
    case FETCH_PENDING_COURSES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PENDING_COURSES_SUCCESS:
      return { ...state, loading: false, pendingCourses: action.payload };
    case FETCH_PENDING_COURSES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case APPROVE_COURSE_SUCCESS:
      return {
        ...state,
        pendingCourses: state.pendingCourses.filter(
          (course) => course.teacherCourseId !== action.payload
        ),
        error: null,
      };
    case APPROVE_COURSE_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

// Approved courses reducer
const initialStateApproved = {
  loading: false,
  approvedCourses: [],
  error: null,
};

export const courseApprovalsReducer = (
  state = initialStateApproved,
  action
) => {
  switch (action.type) {
    case FETCH_APPROVED_COURSES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_APPROVED_COURSES_SUCCESS:
      return { ...state, loading: false, approvedCourses: action.payload };
    case FETCH_APPROVED_COURSES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case MARK_COURSE_PENDING_SUCCESS:
      return {
        ...state,
        approvedCourses: state.approvedCourses.filter(
          (course) => course.teacherCourseId !== action.payload
        ),
        error: null,
      };
    case MARK_COURSE_PENDING_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
